module.exports = __webpack_public_path__ + "img/auditor.5e114574.svg";